import React from "react";
import { Alignment, FloatingArrowProps, Side } from "@floating-ui/react";
import { platform } from "@floating-ui/react-dom";

export const FloatingDot = React.forwardRef(function FloatingArrow(
  {
    id,
    scale = 1,
    context: {
      placement,
      elements: { floating },
      middlewareData: { arrow },
      ...restContext
    },
    staticOffset,
    style: { transform, ...restStyle } = {},
    ...rest
  }: Pick<FloatingArrowProps, "context" | "staticOffset" | "style" | "className"> & { id?: string; scale?: number },
  ref: React.Ref<any>
): React.JSX.Element | null {
  if (!floating) {
    return null;
  }

  const [side, alignment] = placement.split("-") as [Side, Alignment];
  const isRTL = platform.isRTL(floating);

  const yOffsetProp = staticOffset && alignment === "end" ? "bottom" : "top";
  let xOffsetProp = staticOffset && alignment === "end" ? "right" : "left";
  if (staticOffset && isRTL) {
    xOffsetProp = alignment === "end" ? "left" : "right";
  }

  const arrowX = arrow?.x != null ? staticOffset || arrow.x : "0";
  const arrowY = arrow?.y != null ? staticOffset || arrow.y : "0";

  const rotation = {
    top: "",
    left: "rotate(-90deg)",
    bottom: "rotate(180deg)",
    right: "rotate(90deg)",
  }[side];

  transform = ` translate(0, calc(var(--pyne-dot-size) / 2 + 10px)) ${scale !== 1 ? `scale(${scale})` : ""}`;

  const style = {
    position: "absolute",
    pointerEvents: "none",
    [xOffsetProp]: arrowX,
    [yOffsetProp]: arrowY,
    [side]: `calc(100% - var(--pyne-dot-size))`,
    transform: `${rotation}${transform ?? ""}`,
    ...restStyle,
  } as React.CSSProperties;

  return <div {...rest} id={id} className="pyne-dot" ref={ref} style={style}></div>;
});
